
import XButton from 'vux/src/components/x-button/index.vue'

export default {
data(){
return{
imgList:['./static/01.png','./static/02.png','./static/03.png','./static/04.png','./static/05.png'],
src:''
}
},
components: {
XButton,
},
mounted(){
this.src = this.imgList[parseInt(Math.random()*5)]
},
methods:{
share(){
console.log('1')

this.$emit('saveImg','true')
}
}
}



// WEBPACK FOOTER //
// ./src/components/share.vue